// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"537":"ec75dc0d","622":"be80c7b1","809":"525dacdb","955":"fdf4b989"}[chunkId] + ".chunk.js";
};